/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LicenseCreate
 */
export interface LicenseCreate {
    /**
     * 
     * @type {string}
     * @memberof LicenseCreate
     */
    license_type: string;
    /**
     * 
     * @type {Date}
     * @memberof LicenseCreate
     */
    valid_until?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof LicenseCreate
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the LicenseCreate interface.
 */
export function instanceOfLicenseCreate(value: object): value is LicenseCreate {
    if (!('license_type' in value) || value['license_type'] === undefined) return false;
    return true;
}

export function LicenseCreateFromJSON(json: any): LicenseCreate {
    return LicenseCreateFromJSONTyped(json, false);
}

export function LicenseCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'license_type': json['license_type'],
        'valid_until': json['valid_until'] == null ? undefined : (new Date(json['valid_until'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function LicenseCreateToJSON(json: any): LicenseCreate {
    return LicenseCreateToJSONTyped(json, false);
}

export function LicenseCreateToJSONTyped(value?: LicenseCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'license_type': value['license_type'],
        'valid_until': value['valid_until'] == null ? undefined : ((value['valid_until'] as any).toISOString()),
        'notes': value['notes'],
    };
}

